var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeOptions,
          expression: "closeOptions"
        }
      ],
      staticClass: "app-dropdown",
      class: {
        "app-dropdown--disabled": _vm.$attrs.disabled,
        "app-dropdown--error": _vm.hasError
      }
    },
    [
      _vm.$slots.default
        ? _c(
            "div",
            { staticClass: "app-dropdown__label" },
            [
              _vm.$attrs.required
                ? _c("span", { staticClass: "require-mark" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-dropdown__wrapper" }, [
        _c(
          "div",
          { staticClass: "app-dropdown__toggle", on: { click: _vm.toggle } },
          [
            _c("input", {
              staticClass: "app-dropdown__hidden",
              attrs: { type: "text", required: _vm.$attrs.required },
              domProps: { value: _vm.hasValue ? 1 : "" },
              on: { invalid: _vm.setInvalidMessage }
            }),
            _vm._v(" "),
            _vm.hasValue
              ? _c(
                  "div",
                  { staticClass: "app-dropdown__selected" },
                  [
                    _vm.isMultiple
                      ? [
                          _vm._l(_vm.selected, function(option, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _vm._t(
                                  "selected",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "app-dropdown__value app-dropdown__value--tag"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              option[_vm.displayProp] || option
                                            ) +
                                            "\n\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "app-dropdown__remove",
                                            class: {
                                              "app-dropdown__remove--disabled":
                                                _vm.$attrs.disabled
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.remove(option)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t×\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  {
                                    props: {
                                      option: option,
                                      remove: _vm.remove
                                    }
                                  }
                                )
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _vm.canAdd
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.itemToAdd,
                                    expression: "itemToAdd"
                                  }
                                ],
                                staticClass: "app-dropdown__toadd",
                                attrs: { type: "text" },
                                domProps: { value: _vm.itemToAdd },
                                on: {
                                  keydown: _vm.enter,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.itemToAdd = $event.target.value
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      : [
                          _vm._t(
                            "selected",
                            [
                              _c(
                                "span",
                                { staticClass: "app-dropdown__value" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.selected[_vm.displayProp] ||
                                          _vm.selected
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            {
                              props: {
                                option: _vm.selected,
                                remove: _vm.remove
                              }
                            }
                          )
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canAdd && !_vm.hasValue
              ? _c("div", { staticClass: "app-dropdown__selected" }, [
                  _vm.canAdd
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.itemToAdd,
                            expression: "itemToAdd"
                          }
                        ],
                        staticClass: "app-dropdown__toadd",
                        attrs: { type: "text" },
                        domProps: { value: _vm.itemToAdd },
                        on: {
                          keydown: _vm.enter,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.itemToAdd = $event.target.value
                          }
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasValue
              ? _c("div", {
                  staticClass: "app-dropdown__placeholder",
                  class: {
                    "app-dropdown__placeholder--empty": !_vm.$attrs.placeholder
                  },
                  domProps: {
                    textContent: _vm._s(_vm.$attrs.placeholder || " ")
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "app-dropdown__arrow",
              class: { "app-dropdown__arrow--up": _vm.open }
            })
          ]
        ),
        _vm._v(" "),
        _vm.open
          ? _c(
              "div",
              {
                staticClass: "app-dropdown__options-wrapper",
                class: {
                  "app-dropdown__options-wrapper--top": _vm.getPositionReference()
                    .isTop,
                  "app-dropdown__options-wrapper--right": _vm.getPositionReference()
                    .isRight
                }
              },
              [
                _vm.searchable
                  ? _c(
                      "div",
                      { staticClass: "app-dropdown__search" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search,
                              expression: "search"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Search" },
                          domProps: { value: _vm.search },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.search = $event.target.value
                              },
                              function($event) {
                                return _vm.$emit("search", $event.target.value)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("AppIcon", {
                          staticClass: "icon",
                          attrs: {
                            "icon-color": "#778395",
                            "icon-name": "search"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "app-dropdown__options",
                    on: { scroll: _vm.handleScroll }
                  },
                  [
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.checkSearchMatch(
                                option[_vm.displayProp] || option
                              ),
                              expression:
                                "checkSearchMatch(option[displayProp] || option)"
                            }
                          ],
                          key: index,
                          staticClass: "app-dropdown__option",
                          class: {
                            "app-dropdown__option--selected": _vm.isSelected(
                              option
                            ),
                            "app-dropdown__option--disabled": _vm.isDisabled(
                              option
                            ),
                            "app-dropdown__option--itilicized":
                              _vm.itilicizedLastOption &&
                              index === _vm.options.length - 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.select(option)
                            }
                          }
                        },
                        [
                          _vm.checkbox
                            ? _c("span", { staticClass: "checkbox" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t(
                            "option",
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(option[_vm.displayProp] || option) +
                                  "\n                            "
                              ),
                              _vm.descriptionProp && option[_vm.descriptionProp]
                                ? _c("p", { staticClass: "description-prop" }, [
                                    _vm._v(
                                      "\n                                (" +
                                        _vm._s(option[_vm.descriptionProp]) +
                                        ")\n                            "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            {
                              props: {
                                option: option,
                                isSelected: _vm.isSelected(option)
                              }
                            }
                          )
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "app-dropdown__empty"
                      },
                      [
                        _vm._t("loading", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s("Loading...") +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEmpty,
                            expression: "isEmpty"
                          }
                        ],
                        staticClass: "app-dropdown__empty"
                      },
                      [
                        _vm._t("empty", [_c("span", [_vm._v("No item found")])])
                      ],
                      2
                    )
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.hasError
        ? _c("p", { staticClass: "app-dropdown__error" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.invalidMessage || _vm.error) + "\n\t\t"
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48430c75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48430c75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppDropdown.vue
// module id = null
// module chunks = 